import React from "react";
import { Breadcrumb } from "reactstrap";
import { BreadcrumbCustomItem } from "components/_ProductConfigurator/Breadcrumb/BreadcrumbCustomItem";

export const BreadCrumbs = ({ breadcrumbList, classNames }) => (
  <Breadcrumb listTag="div" className={classNames}>
    {breadcrumbList.map((item, index) => (
      <BreadcrumbCustomItem
        key={index}
        isLastItem={index === breadcrumbList.length - 1}
        withChevron={index}
        {...item}
      />
    ))}
  </Breadcrumb>
);
